import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
const FIELD_LABEL_KEYS = {
    fancyName: 'no_fancy_name.label',
    itemCode: 'no_item_code.label',
    brand: 'no_brand.label',
    category: 'no_category.label',
    season: 'no_season.label',
    productionTimeMinutes: 'no_production_time.label',
};
function getFieldError(field, form, t) {
    var _a;
    if (field === 'productionTimeMinutes') {
        return !form.productionTimeMinutes || form.productionTimeMinutes <= 0
            ? t('specification:required_field')
            : null;
    }
    if (field === 'brand' || field === 'category' || field === 'season') {
        return !form[field] ? t('specification:required_field') : null;
    }
    return !((_a = form[field]) === null || _a === void 0 ? void 0 : _a.trim())
        ? t('specification:required_field')
        : null;
}
function useSummaryValidation(form, t) {
    const validatedFields = useMemo(() => ['fancyName', 'itemCode', 'brand', 'category', 'season', 'productionTimeMinutes'], []);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, form, t), (field) => t(`specification:${FIELD_LABEL_KEYS[field]}`));
}
export default useSummaryValidation;
